export const EVENTS = {
  USER_JOINED: "user-joined",
  USER_LEFT: "user-left",
  CONNECT_ME: "join-room",
};
export const SOCKET_SERVER_URI = "https://live-now-backend.herokuapp.com/";
// export const SOCKET_SERVER_URI = "http://localhost:8080/";

export const PEER_SERVER_CONFIG = {
  host: "peerjserver.herokuapp.com",
  // port: 80,
  port: window.location.protocol === "https:" ? 443 : 80,
  path: "/peerjs",
};
